import { render, staticRenderFns } from "./CostosPorCategoriaMantenimiento.vue?vue&type=template&id=3ae1c35e&"
import script from "./CostosPorCategoriaMantenimiento.vue?vue&type=script&lang=js&"
export * from "./CostosPorCategoriaMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports